import React, { useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { atoms, Button, type ButtonProps, VStack } from '@rtkwlf/fenrir-react';
import { faFileImport } from '@rtkwlf/pro-solid-svg-icons/faFileImport';
import { parse } from 'papaparse';
import { useTranslation } from 'react-i18next';

interface Props extends ButtonProps {
  onFileChange: (data: string[][]) => void;
  testId?: string;
  isDisabled?: boolean;
}

const hiddenInputClass = atoms({
  display: 'none',
});

export const CsvUpload = ({
  onFileChange,
  testId = 'csv-upload-hidden-input',
  ...rest
}: Props) => {
  const { t } = useTranslation('icon');
  const [csvFile, setCsvFile] = useState<File>();
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!csvFile) return;

    parse<string[]>(csvFile, {
      worker: true,
      skipEmptyLines: true,
      complete: ({ data }) => {
        onFileChange(data);
        setCsvFile(undefined);
      },
    });
  }, [csvFile, onFileChange]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setCsvFile(e.target.files[0]);
      e.target.value = '';
    }
  };

  const handleClick = () => hiddenFileInput.current?.click();

  return (
    <VStack>
      <Button
        onClick={handleClick}
        iconLeft={<FontAwesomeIcon icon={faFileImport} />}
        {...rest}
      >
        {t('importText')}
      </Button>
      <input
        ref={hiddenFileInput}
        className={hiddenInputClass}
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        data-testid={testId}
      />
    </VStack>
  );
};
